// @带带大师兄

import {vm} from '../../../main'
// import Snap from 'snap.svg'
(function(win, doc) {
    var map ;
    var $ ;
    function Fly(options , map , $Jquery) {
        if(!options){
            alert('请传入需要初始化的区域');
        }
        else{
            this.map = map;
            this.$ = $Jquery;
            this.s=Snap(options.el);  //初始化svg
            this.rotate=options.rotate || 15;  //旋转角度
            this.space=options.space || 15;    //飞行间隔
            this.startPoint=options.startPoint || {  //起点
                    lng: 116.402,
                    lat: 39.915
            };
            this.pointArr=[];   //顶点数组
        }

    }

    /**@method 改变旋转角度
     * @param {Number} rotate - 旋转角度
     */
    Fly.prototype.changeRotate=function(rotate){
        this.rotate=rotate;
    };
    /**@method 改变间距
     * @param {Number} space - 间距
     */
    Fly.prototype.changeSpace=function(space){
        this.space=space;
    };

    /**@method 画出航线
     */
    Fly.prototype.reset=function(){
        var polygon=this.pointArr;
        var space  =this.space;
        var rotate = this.rotate;
        console.log(this.pointArr  + "===" + this.space + "===" + this.rotate)

        var outRect=this.createPolygonBounds(polygon);
        /**创建变换后的多边形*/
        var rPolygon=this.createRotatePolygon(polygon,outRect,-rotate);

        var outRect2 = this.createPolygonBounds(rPolygon);
        var latLines = this.calcLatsInPolygon(outRect2, space);

        /**纬度线*/
        var polyline=[];
        /**遍历每一条纬度线*/
        for(var i=0;i<latLines.len;i++){
            var arr=[];
            /**遍历每一个多边形顶点*/
            for(var j=0;j<rPolygon.length;j++){
                var point=this.calcPointInLineWithY([
                    rPolygon[j].lng,
                    rPolygon[j].lat
                ],[
                    rPolygon[this.si(j+1,rPolygon.length)].lng,
                    rPolygon[this.si(j+1,rPolygon.length)].lat
                ],outRect2.northLat - i*latLines.lat);
                if(point){
                    arr.push(point)
                }
            }


            /**去掉只有一个交点的纬度线*/
            if(arr.length<2){
                continue
            }


            /**去掉两个交点重合的纬度线*/
            if(arr[0][0] === arr[1][0]){
                if(arr.length>2){
                    arr.splice(0,1);
                }
                else {
                    continue
                }

            }
            if (i % 2) {
                polyline.push({
                    lat: arr[0][1],
                    lng: Math.max(arr[0][0], arr[1][0])
                }, {
                    lat: arr[0][1],
                    lng: Math.min(arr[0][0], arr[1][0])
                })
            } else {
                polyline.push({
                    lat: arr[0][1],
                    lng: Math.min(arr[0][0], arr[1][0])
                }, {
                    lat: arr[0][1],
                    lng: Math.max(arr[0][0], arr[1][0])
                })
            }
        }

        this.draw(polyline,outRect);
    }
    /**@method 画出航线
     * @param {Array} polyline - 顶点的数组
     * @param {Object} outRect - 外接矩形的顶点
     */
    Fly.prototype.draw=function(polyline,outRect){
        var rotate=this.rotate;
       /* if(this.s.select("#inLine")){
            this.s.select("#inLine").remove();
        }*/
        var line=this.createRotatePolygon(polyline,outRect,rotate);
        var pathStr=[];
        for(var i=0;i<line.length;i++){
           pathStr.push(new BMap.Point(line[i].lng, line[i].lat));
        }
        var overlays=this.map.getOverlays();
        for(var i=0;i<overlays.length;i++){
            if(overlays[i].hasOwnProperty('id')&&overlays[i].id=="inLine"){
                this.map.removeOverlay(overlays[i]);
                break;
            }
        }
        var mapLine = new BMap.Polyline(pathStr, {strokeColor:"red", strokeWeight:3, strokeOpacity:0.5});
        this.map.addOverlay(mapLine);   //增加多边形
        mapLine.id="inLine";

        var totalLength= this.$(mapLine.V)[0].getTotalLength()+parseInt(this.$('#one span').html());
        this.$('#distance').html((totalLength).toFixed(2));//航线长度
        vm.__proto__.$page.totalLength = totalLength
        var speed = this.$('#flySpeed .text span').html();
        var time = (totalLength / speed).toFixed(2);
        this.$('#time span').html(time);//航线长度
        this.$('#pointsNum span').html(polyline.length);//航点数
        var photoNum = parseInt(this.$('.gap .text span').html())/100;
        this.$('#photoNum span').html(parseInt(time / photoNum));//拍照数
    }

    Fly.prototype.getPath=function(arr){
        var str="";
        for(var i=0;i<arr.length;i++){
            if(i==0){
                str+='M'+arr[i].lng+" "+arr[i].lat;
            }
            else {
                str+='L'+arr[i].lng+" "+arr[i].lat;
            }
        }
        str+="Z";
        return str;
    }
    /**@method 获取前进切线角度，用于飞机沿路线飞行时要旋转的角度
     * @param {Object} a - 点
     * @param {Object} b - 点
     */
    Fly.prototype.getRotate=function(a, b) {
        var k = (b.y - a.y) / (b.x - a.x);
        var rotate = Math.atan(k) * 180 / Math.PI;
        return k < 0 ? rotate + 90 : rotate - 90;
    }

    /**防止索引溢出*/
    Fly.prototype.si=function(i,l){
        if (i > l - 1) {
            return i - l;
        }
        if (i < 0) {
            return l + i;
        }
        return i;
    }

    /**@method 创建多边形外接矩形
     * @param {Array} latlngs - 格式为[{lat,lng}]的经纬度数组，多边形的顶点集合
     * @return {Array} .rect - 返回外接矩形四顶点
     * @return {Object} .center - 返回外接矩形的中心的
     */
    Fly.prototype.createPolygonBounds=function(latlngs) {
        var lats = [];
        var lngs = [];
        for (var i = 0; i < latlngs.length; i++) {
            lats.push(latlngs[i].lat);
            lngs.push(latlngs[i].lng);
        }
        var maxLat = Math.max.apply(Math, lats);
        var maxLng = Math.max.apply(Math, lngs);
        var minLat = Math.min.apply(Math, lats);
        var minLng = Math.min.apply(Math, lngs);
        return {
            center: {
                lat: (maxLat + minLat) / 2,
                lng: (maxLng + minLng) / 2
            },
            latlngs: [{
                lat: maxLat,
                lng: minLng
            }, {
                lat: maxLat,
                lng: maxLng
            }, {
                lat: minLat,
                lng: maxLng
            }, {
                lat: minLat,
                lng: minLng
            }],
            northLat: maxLat
        }
    }

    /**@method 计算有多少条纬度线穿过
     * @param {Array} rect - 外接矩形
     * @param {Number} space - 间隔
     */
    Fly.prototype.calcLatsInPolygon=function(rect,space){
        var nw = rect.latlngs[0];
        var sw = rect.latlngs[3];
        var dis = this.distance({
            lat: nw.lat,
            lng: nw.lng
        }, {
            lat: sw.lat,
            lng: sw.lng
        });
        var steps = parseInt(dis / space / 2);
        var lats = (nw.lat - sw.lat) / steps;
        return {
            len: steps,
            lat: lats
        }
    }

    Fly.prototype.transform=function(x, y, tx, ty, deg, sx, sy) {
        var deg = deg * Math.PI / 180;
        if (!sy) sy = 1;
        if (!sx) sx = 1;
        return [
            sx * ((x - tx) * Math.cos(deg) - (y - ty) * Math.sin(deg)) + tx,
            sy * ((x - tx) * Math.sin(deg) + (y - ty) * Math.cos(deg)) + ty
        ]
    }

    Fly.prototype.calcPointInLineWithY=function(p1,p2,y){
        var s = p1[1] - p2[1];
        var x;
        if (s) {
            x = (y - p1[1]) * (p1[0] - p2[0]) / s + p1[0]
        } else {
            return false
        }

        /**判断x是否在p1,p2在x轴的投影里，不是的话返回false*/
        if (x > p1[0] && x > p2[0]) {
            return false
        }
        if (x < p1[0] && x < p2[0]) {
            return false
        }
        return [x, y]
    }
    /**@method 创建一个旋转后的多边形
     * @param {Array}  latlngs - 经纬度顶点集
     * @param {Object} bounds - 由上文  createPolygonBounds 函数创建的对象
     * @param {Number} rotate - 旋转角度
     * @return {Array} - 变换后的经纬度数组
     */
    Fly.prototype.createRotatePolygon=function(latlngs, bounds, rotate){
        var res=[];
        for(var i=0;i<latlngs.length;i++){
            var tr=this.transform(
                latlngs[i].lng,
                latlngs[i].lat,
                bounds.center.lng,
                bounds.center.lat,
                rotate
            );
            res.push({lat:tr[1],lng:tr[0]});
        }
        return res

    }

    /**@method 获取两个经纬度点的距离
     * @param {Object} p1,p2 - 两个经纬度点
     * @return {Number} 单位 米
     */
    Fly.prototype.distance=function(p1,p2){
        //return Math.pow(((p1.lat-p2.lat) * (p1.lat-p2.lat) + (p1.lng-p2.lng) * (p1.lng-p2.lng)), 0.5)
        var dis= this.map.getDistance(new BMap.Point(p1.lng, p1.lat), new BMap.Point(p2.lng, p2.lat));
        return  dis;
    }

    /**@method 判断是否在线的左侧
     * @param {Object} p - 点
     * @param {Object} p1 - 连成直线的一个点
     * @param {Object} p2 - 连成直线的一个点
     */
    Fly.prototype.LeftOfLine=function(p,p1,p2)
    {
        var tmpx = (p1.lng - p2.lng) / (p1.lat - p2.lat) * (p.lat - p2.lat) + p2.lng;
        if (tmpx > p.lng)//当tmpx>p.x的时候，说明点在线的左边，小于在右边，等于则在线上。
        {
            return true;
        }
        else {
            return false;
        }

    }

    /**@method 设置经纬度转换成页面像素坐标的方法
     * @param {Object} latlng - {lat,lng}
     */
    Fly.prototype.latlng2px=function(latlng){
        /**百度，map为 new BMap.Map() 对象*/
        return map.pointToPixel(new BMap.Point(latlng.lng, latlng.lat))
    };

    /**@method 设置像素坐标转换成经纬度点的方法
     * @param {Array} px - [lng,lat]
     */
    Fly.prototype.px2latlng=function(px){
        /**百度，map为 new BMap.Map() 对象*/
        return map.pixelToPoint(new BMap.Pixel(px[0], px[1]));
    };

    /**@method 设置像素坐标转换成经纬度点的方法
     * @param {Array} polygon - 多边形
     */
    Fly.prototype.getArea=function(polygon){
        // 检查类型：既不是百度类型的范围又不是数组类型的数据，直接返回0
        if (!(polygon instanceof BMap.Polygon) && !(polygon instanceof Array)) {
            return 0;
        }

        //如果是百度类型的，得到点集合，不是的话，另说。
        var pts = new Array();
        if (polygon instanceof BMap.Polygon) {
            pts = polygon.getPath();
        }

        //判断数组的长度，如果是小于3的话，不构成面，无法计算面积
        if (pts.length < 3) {
            return 0;
        }

        var totalArea = 0;// 初始化总面积
        var LowX = 0.0;
        var LowY = 0.0;
        var MiddleX = 0.0;
        var MiddleY = 0.0;
        var HighX = 0.0;
        var HighY = 0.0;
        var AM = 0.0;
        var BM = 0.0;
        var CM = 0.0;
        var AL = 0.0;
        var BL = 0.0;
        var CL = 0.0;
        var AH = 0.0;
        var BH = 0.0;
        var CH = 0.0;
        var CoefficientL = 0.0;
        var CoefficientH = 0.0;
        var ALtangent = 0.0;
        var BLtangent = 0.0;
        var CLtangent = 0.0;
        var AHtangent = 0.0;
        var BHtangent = 0.0;
        var CHtangent = 0.0;
        var ANormalLine = 0.0;
        var BNormalLine = 0.0;
        var CNormalLine = 0.0;
        var OrientationValue = 0.0;
        var AngleCos = 0.0;
        var Sum1 = 0.0;
        var Sum2 = 0.0;
        var Count2 = 0;
        var Count1 = 0;
        var Sum = 0.0;
        var Radius = 6378137.0;// ,WGS84椭球半径
        var Count = pts.length;
        for ( var i = 0; i < Count; i++) {
            if (i == 0) {
                LowX = pts[Count - 1].lng * Math.PI / 180;
                LowY = pts[Count - 1].lat * Math.PI / 180;
                MiddleX = pts[0].lng * Math.PI / 180;
                MiddleY = pts[0].lat * Math.PI / 180;
                HighX = pts[1].lng * Math.PI / 180;
                HighY = pts[1].lat * Math.PI / 180;
            } else if (i == Count - 1) {
                LowX = pts[Count - 2].lng * Math.PI / 180;
                LowY = pts[Count - 2].lat * Math.PI / 180;
                MiddleX = pts[Count - 1].lng * Math.PI / 180;
                MiddleY = pts[Count - 1].lat * Math.PI / 180;
                HighX = pts[0].lng * Math.PI / 180;
                HighY = pts[0].lat * Math.PI / 180;
            } else {
                LowX = pts[i - 1].lng * Math.PI / 180;
                LowY = pts[i - 1].lat * Math.PI / 180;
                MiddleX = pts[i].lng * Math.PI / 180;
                MiddleY = pts[i].lat * Math.PI / 180;
                HighX = pts[i + 1].lng * Math.PI / 180;
                HighY = pts[i + 1].lat * Math.PI / 180;
            }
            AM = Math.cos(MiddleY) * Math.cos(MiddleX);
            BM = Math.cos(MiddleY) * Math.sin(MiddleX);
            CM = Math.sin(MiddleY);
            AL = Math.cos(LowY) * Math.cos(LowX);
            BL = Math.cos(LowY) * Math.sin(LowX);
            CL = Math.sin(LowY);
            AH = Math.cos(HighY) * Math.cos(HighX);
            BH = Math.cos(HighY) * Math.sin(HighX);
            CH = Math.sin(HighY);
            CoefficientL = (AM * AM + BM * BM + CM * CM)/ (AM * AL + BM * BL + CM * CL);
            CoefficientH = (AM * AM + BM * BM + CM * CM)/ (AM * AH + BM * BH + CM * CH);
            ALtangent = CoefficientL * AL - AM;
            BLtangent = CoefficientL * BL - BM;
            CLtangent = CoefficientL * CL - CM;
            AHtangent = CoefficientH * AH - AM;
            BHtangent = CoefficientH * BH - BM;
            CHtangent = CoefficientH * CH - CM;
            AngleCos = (AHtangent * ALtangent + BHtangent * BLtangent + CHtangent* CLtangent)/ (Math.sqrt(AHtangent * AHtangent + BHtangent* BHtangent + CHtangent * CHtangent) * Math.sqrt(ALtangent * ALtangent + BLtangent* BLtangent + CLtangent * CLtangent));
            AngleCos = Math.acos(AngleCos);
            ANormalLine = BHtangent * CLtangent - CHtangent * BLtangent;
            BNormalLine = 0 - (AHtangent * CLtangent - CHtangent* ALtangent);
            CNormalLine = AHtangent * BLtangent - BHtangent * ALtangent;
            if (AM != 0)
                OrientationValue = ANormalLine / AM;
            else if (BM != 0)
                OrientationValue = BNormalLine / BM;
            else
                OrientationValue = CNormalLine / CM;
            if (OrientationValue > 0) {
                Sum1 += AngleCos;
                Count1++;
            } else {
                Sum2 += AngleCos;
                Count2++;
            }
        }

        var tempSum1, tempSum2;
        tempSum1 = Sum1 + (2 * Math.PI * Count2 - Sum2);
        tempSum2 = (2 * Math.PI * Count1 - Sum1) + Sum2;
        if (Sum1 > Sum2) {
            if ((tempSum1 - (Count - 2) * Math.PI) < 1)
                Sum = tempSum1;
            else
                Sum = tempSum2;
        } else {
            if ((tempSum2 - (Count - 2) * Math.PI) < 1)
                Sum = tempSum2;
            else
                Sum = tempSum1;
        }
        totalArea = (Sum - (Count - 2) * Math.PI) * Radius * Radius;

        return totalArea; // 返回总面积
    }

    win.Fly = Fly;
})(window, document);


// WEBPACK FOOTER //
// ./src/components/Altizure/js/xunfei.js